import 'css-chunksrc/client/scenes/projectMembersListingConfiguration/form/columns/styles.scss';export default {
  "columns": "_columns_1bu5r_1",
  "columnWrapper": "_columnWrapper_1bu5r_7",
  "column": "_column_1bu5r_1",
  "iconBox": "_iconBox_1bu5r_27",
  "icon": "_icon_1bu5r_27",
  "columnIcon": "_columnIcon_1bu5r_45",
  "hidden": "_hidden_1bu5r_54"
};